export default __webpack_public_path__ + "static/media/behave.91c237af.jpg";